import { Link } from 'react-router-dom';
import { PageHeader, StatCard } from '../components/UI';
import { useAuth } from '../state/AuthContext';

export function AdminDashboard() {
  const { user } = useAuth();
  return (
    <section className="portal-page">
      <PageHeader title={`Welcome, ${user?.displayName}`} description="Phase 1 control centre for content, roles, reviews and platform readiness." actions={<Link className="button" to="/admin/import">Import questions</Link>} />
      <div className="stats-grid">
        <StatCard label="Question drafts" value="16,000" note="Ready for controlled import" />
        <StatCard label="Pending review" value="16,000" note="Nothing publishes automatically" tone="amber" />
        <StatCard label="3D asset specs" value="22,960" note="Rendering and QA pending" tone="purple" />
        <StatCard label="Security" value="RLS" note="Policies included in migrations" tone="green" />
      </div>
      <div className="dashboard-grid">
        <article className="panel">
          <div className="panel-heading"><div><p className="eyebrow">Content pipeline</p><h2>Publishing readiness</h2></div><span className="pill amber">Blocked until QA</span></div>
          {[
            ['Automated structure validation', 100],
            ['Teacher content review', 0],
            ['Urdu specialist review', 0],
            ['Islamiat specialist review', 0],
            ['3D visual review', 0],
          ].map(([label, value]) => <div className="progress-row" key={String(label)}><span>{label}</span><div><i style={{ width: `${value}%` }} /></div><strong>{value}%</strong></div>)}
        </article>
        <article className="panel">
          <p className="eyebrow">Next actions</p><h2>Foundation checklist</h2>
          <ul className="check-list">
            <li className="done">Frontend scaffold</li>
            <li className="done">Database migrations</li>
            <li className="done">Role guards and portal shells</li>
            <li>Apply migrations to staging Supabase</li>
            <li>Create first Super Admin</li>
            <li>Run RLS acceptance tests</li>
          </ul>
        </article>
      </div>
    </section>
  );
}

export function ReviewerDashboard() {
  return <RoleDashboard title="Reviewer Dashboard" description="Review educational wording, answers, age suitability and visual quality." cards={[['Awaiting content review', '0'], ['Awaiting visual review', '0'], ['Changes requested', '0'], ['Approved today', '0']]} />;
}

export function TeacherDashboard() {
  return <RoleDashboard title="Teacher Dashboard" description="Manage classes, assignments and learning reports." cards={[['Active classes', '0'], ['Students', '0'], ['Open assignments', '0'], ['Average completion', 'â€”']]} />;
}

export function ParentDashboard() {
  return <RoleDashboard title="Parent Dashboard" description="Create child profiles and follow learning progress safely." cards={[['Child profiles', '0'], ['Weekly quizzes', '0'], ['Assignments due', '0'], ['Words mastered', '0']]} />;
}

export function StudentDashboard() {
  return (
    <section className="portal-page student-dashboard">
      <PageHeader title="Hi! Piko is ready to learn." description="Choose a safe practice activity or continue an assignment." />
      <div className="student-actions">
        <Link to="/student/practice" className="learning-card blue"><span>Quiz Practice</span><strong>Start a mixed quiz</strong></Link>
        <Link to="/learn/tables" className="learning-card orange"><span>Pikoâ€™s Math Tables</span><strong>Build fact mastery</strong></Link>
        <Link to="/learn/words" className="learning-card purple"><span>Pikoâ€™s Word World</span><strong>Spell and learn meanings</strong></Link>
      </div>
      <div className="piko-message"><img src="/brand/piko-parrot-mascot.png" alt="Piko parrot mascot" /><div><h2>Your progress will appear here.</h2><p>Complete the Supabase setup, add a child profile and assign a quiz to activate live progress.</p></div></div>
    </section>
  );
}

function RoleDashboard({ title, description, cards }: { title: string; description: string; cards: string[][] }) {
  return (
    <section className="portal-page">
      <PageHeader title={title} description={description} />
      <div className="stats-grid">{cards.map(([label, value], index) => <StatCard key={label} label={label} value={value} note={index === 0 ? 'Ready after Supabase setup' : 'No records yet'} tone={['blue', 'green', 'amber', 'purple'][index]} />)}</div>
      <div className="empty-state"><img src="/brand/piko-parrot-mascot.png" alt="Piko parrot mascot" /><h3>Your workspace is ready</h3><p>Empty states are intentional until authenticated records are created.</p></div>
    </section>
  );
}


